var React = require('react');

function Notfallaufnahme (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.8429 26.5306C19.8663 26.5306 25.6859 20.7111 25.6859 13.6877C25.6859 6.66415 19.8665 0.844727 12.8429 0.844727C5.81946 0.844727 0 6.66415 0 13.6877C0 20.7111 5.81943 26.5306 12.8429 26.5306Z","fill":"#E30613","key":0}),React.createElement("path",{"d":"M11.2383 5.86182V21.5142H14.6497V5.86182H11.2383Z","fill":"white","key":1}),React.createElement("path",{"d":"M20.6685 11.8818H5.2168V15.2932H20.6685V11.8818Z","fill":"white","key":2})]);
}

Notfallaufnahme.defaultProps = {"width":"26","height":"27","viewBox":"0 0 26 27","fill":"none"};

module.exports = Notfallaufnahme;

Notfallaufnahme.default = Notfallaufnahme;
